import { render, staticRenderFns } from "./EmployeesAttendanceApprover.vue?vue&type=template&id=0b67184d&scoped=true"
import script from "./EmployeesAttendanceApprover.vue?vue&type=script&lang=js"
export * from "./EmployeesAttendanceApprover.vue?vue&type=script&lang=js"
import style0 from "./EmployeesAttendanceApprover.vue?vue&type=style&index=0&id=0b67184d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b67184d",
  null
  
)

export default component.exports